import { Input, Select } from "@ucloud-fe/react-components";
import React from "react";
import validator from "validator";
import action from "../../common/action.js";
import lang from "../../common/lang.js";
import request from "../../common/request.js";
import { getGeetestLanguage, handleSearch } from "../../common/utils.js";
import uuid from "../../common/uuid.js";
import config from "../../config/config.js";
import { isMobile } from "../../service/deviceDetectService.js";
import localeService from "../../service/localeService.js";
import loginService from "../../service/loginService.js";
import registerService from "../../service/registerService.js";
import CodeModal from "./CodeModal.jsx";

class PhoneInput extends React.Component {
  constructor(props) {
    super(props);
    this.lang = lang.getLang("_lang");
    this.countryListCloseHandler = this.countryListClose.bind(this);
    this.verifySid = uuid();
    this.handleSendCode = () => {};
    this.state = {
      isCountryOpen: false,
      countryList: [],
      phoneCountSecond: 0,
      phoneInterval: 0,
      showCodeModal: false,
      showPicureCodeInput: true,
    };
  }

  componentDidMount() {
    this.initVerify();
    registerService.fetchCountryList().then((data) => {
      this.setState({ countryList: data || [] });
    });
  }

  // 极验初始化
  initVerify() {
    let self = this;
    request(action.register.RegisterGeekVerification, {
      ClientType: "web",
      Applicant: "SendPhoneVerificationCodeV2",
      GeeTestVersion: "4.0",
    })
      .success((res) => {
        let succ = res && res.GeetestId;
        if (succ && res.Model === "geektest") {
          return window.initGeetest4(
            {
              captchaId: res.GeetestId,
              product: "bind",
              protocol: "https://",
              language: getGeetestLanguage(),
            },
            function (captchaObj) {
              captchaObj
                .onReady(function () {})
                .onSuccess(function () {
                  const res = captchaObj.getValidate();
                  const result = {
                    GeeTestVersion: "4.0",
                    CaptchaId: res.captcha_id,
                    CaptchaOutput: res.captcha_output,
                    GenTime: res.gen_time,
                    LotNumber: res.lot_number,
                    PassToken: res.pass_token,
                  };
                  return self.sendPhoneCode(result);
                })
                .onError(function () {});
              // 按钮提交事件
              self.handleSendCode = function (e) {
                // 点击函数
                // 检测验证码是否ready, 验证码的onReady是否执行
                e && e.stopPropagation();
                if (!validator.isNumeric(self.props.phoneNumber)) {
                  return self.props.updatePhoneState(
                    "errorMsg",
                    localeService.getTranslate("INVALID_MOBILE")
                  );
                } else if (self.state.phoneCountSecond !== 0) {
                  return false;
                }
                self.props.updatePhoneState("errorMsg", "");
                return captchaObj.showCaptcha();
              };
            }
          );
        } else if (res && res.Model === "picture") {
          self.handleSendCode = function (e) {
            e && e.stopPropagation();
            if (self.state.phoneCountSecond !== 0) {
              return false;
            }
            return self.clickShowCodeModal();
          };
        }
      })
      .fail((err) => {
        self.props.updatePhoneState(
          "errorMsg",
          localeService.getTranslate("LOGIN57")
        );
      });
  }

  // 发送短信验证码
  sendPhoneCode(result) {
    let self = this;
    const data = {
      UserPhone: `(${self.props.country})${self.props.phoneNumber}`,
      VerifyType: "SMS_LOGIN",
      ...result,
    };
    loginService
      .sendPhoneVerificationCodeV2(data)
      .then(function () {
        self.setSendTime();
      })
      .catch(function (data) {
        if (data["RetCode"] == "11097" || data["RetCode"] == "11098") {
          self.props.updatePhoneState("errorMsg", "");
          self.setState({
            PictureCode: "",
            pictureCodeErrorMsg: data['I18N-Message'] || localeService.getTranslate(data["RetCode"]),
          });
          return;
        }
        self.props.updatePhoneState(
          "errorMsg",
          data['I18N-Message'] || localeService.getTranslate(data["RetCode"] || data["Retcode"])
        );
        self.setState({ pictureCodeErrorMsg: "" });
      });
  }

  verifyPictureCodeChange(value) {
    this.setState({
      PictureCode: value,
      pictureCodeErrorMsg: "",
    });
  }

  changeVerifyPictureCode() {
    this.verifySid = uuid();
    this.forceUpdate();
  }

  clickShowCodeModal = () => {
    const { phoneNumber, updatePhoneState } = this.props;
    if (!validator.isNumeric(phoneNumber)) {
      return updatePhoneState(
        "errorMsg",
        localeService.getTranslate("INVALID_MOBILE")
      );
    }
    updatePhoneState("errorMsg", "");
    return this.setState({ showCodeModal: true });
  };

  countryListOpen = () => {
    if (!this.state.isCountryOpen) {
      this.setState({ isCountryOpen: true });
      window.setTimeout(function () {
        window.addEventListener("click", this.countryListCloseHandler);
      });
    } else {
      this.countryListCloseHandler();
    }
  };

  countryListClose = () => {
    this.setState({ isCountryOpen: false });
    window.removeEventListener("click", this.countryListCloseHandler);
  };

  handleCountryChange = (val) => {
    this.props.updatePhoneState("country", val);
    this.countryListCloseHandler();
  };

  setSendTime() {
    var self = this;
    self.setState({ phoneCountSecond: 60 });
    self.phoneInterval = setInterval(function () {
      let _remain = self.state.phoneCountSecond - 1;
      self.setState({ phoneCountSecond: _remain });
      if (_remain <= 0) {
        clearInterval(self.phoneInterval);
        self.phoneInterval = 0;
        return;
      }
    }, 1000);
  }

  sendVerifyCode() {
    var self = this;
    if (!self.props.country) {
      self.props.updatePhoneState(
        "errorMsg",
        localeService.getTranslate("NO_COUNTRY")
      );
      self.setState({ pictureCodeErrorMsg: "" });
      return;
    } else if (!validator.isNumeric(self.props.phoneNumber)) {
      self.props.updatePhoneState(
        "errorMsg",
        localeService.getTranslate("INVALID_MOBILE")
      );
      self.setState({ pictureCodeErrorMsg: "" });
      return;
    }

    let data = {
      VerifyType: "SMS_LOGIN",
      UserPhone: `(${self.props.country})${self.props.phoneNumber}`,
    };

    if (self.state.showPicureCodeInput && !self.state.PictureCode) {
      self.setState({
        pictureCodeErrorMsg: localeService.getTranslate("RETRIEVE18"),
      });
      return;
    }

    if (self.state.PictureCode) {
      data.SID = self.verifySid;
      data.PictureCode = self.state.PictureCode;
    }

    loginService
      .sendPhoneVerificationCodeV2(data)
      .then(function (data) {
        self.setSendTime();
        self.props.updatePhoneState("errorMsg", "");
        self.setState({ showCodeModal: false, pictureCodeErrorMsg: "" });
      })
      .catch(function (data) {
        self.verifySid = uuid();
        if (data["RetCode"] == "11097" || data["RetCode"] == "11098") {
          self.props.updatePhoneState("errorMsg", "");
          self.setState({
            PictureCode: "",
            pictureCodeErrorMsg: data['I18N-Message'] || localeService.getTranslate(data["RetCode"]),
          });
          return;
        }
        self.props.updatePhoneState(
          "errorMsg",
          data['I18N-Message'] || localeService.getTranslate(data["RetCode"] || data["Retcode"])
        );
        self.setState({
          // showPicureCodeInput: false,
          pictureCodeErrorMsg: data['I18N-Message'] || localeService.getTranslate(
            data["RetCode"] || data["Retcode"]
          ),
        });
      });
  }

  changePhoneNumber = (event) => {
    this.props.updatePhoneState("phoneNumber", event.target.value);
  };

  phoneCodeChange = (event) => {
    this.props.updatePhoneState("PhoneCode", event.target.value);
  };

  buildCodeContent() {
    const self = this;
    const _icon = "icon__message";
    const _className = `u-dib u-vt ${_icon} u-ml15 code-icon`;
    const _sentLocale = localeService.getTranslate("LOGIN12");
    if (self.state.phoneCountSecond == 0) {
      return (
        <div
          className="send-code-btn u-blue"
          onClick={() => this.handleSendCode()}
        >
          <span className={_className} />
          <span className="u-dib u-vt desc">
            {localeService.getTranslate("LOGIN11")}
          </span>
        </div>
      );
    } else if (self.state.phoneCountSecond > 0) {
      return (
        <div>
          <span className={_className} />
          <span className="u-dib u-vt desc">
            {_sentLocale}({self.state.phoneCountSecond}s)
          </span>
        </div>
      );
    }
  }

  render() {
    const { countryList, showCodeModal, PictureCode, pictureCodeErrorMsg } =
      this.state;
    const { country, phoneNumber } = this.props;
    const _verifyUrl = `${config.dws}/captcha?SID=${this.verifySid}`;
    return (
      <div>
        <div
          className="selectlist-drawdown"
          ref={(tableDiv) => (this._table = tableDiv)}
        />
        <div
          className="register-cellphone app-form-item u-pos-rel"
          style={{ marginBottom: 24 }}
        >
          <Input
            size="lg"
            onBlur={this.onPhoneBlur}
            value={phoneNumber}
            onChange={this.changePhoneNumber}
            placeholder={localeService.getTranslate("REGISTER01")}
          />
          <div
            className="register-zone-number-wrapper"
            onClick={this.countryListOpen}
          >
            <Select
              size="lg"
              className="uc-select"
              defaultValue={country}
              renderSelector={(c, v) => (
                <div className="uc-select__selected-value">
                  {`+${country}`}
                  {v ? (
                    <span className="uc-select__arrow icon__up" />
                  ) : (
                    <span className="uc-select__arrow icon__down" />
                  )}
                </div>
              )}
              onChange={this.handleCountryChange}
              popoverProps={{
                getPopupContainer: () => this._table,
              }}
              search={{
                handleSearch,
              }}
            >
              {countryList.map((item) => (
                <Select.Option
                  key={item.CountryCode + Math.random()}
                  value={item.PhonePrefix}
                >
                  {this.lang === "EN" ? item.CountryName : item.CountryAlias} (
                  {item.PhonePrefix})
                </Select.Option>
              ))}
            </Select>
          </div>
        </div>
        <div className="app-form-item">
          <Input
            type="text"
            className={isMobile() ? "" : "u-dib u-vm u-mr10"}
            size="lg"
            autoComplete="off"
            placeholder={localeService.getTranslate("RETRIEVE18")}
            onChange={this.phoneCodeChange}
            suffix={
              <div className="phone-code-icon-wrapper u-dib u-vm">
                <div className="phone-code-counter">
                  {this.buildCodeContent()}
                </div>
              </div>
            }
          />
        </div>
        <CodeModal
          visible={showCodeModal}
          _verifyUrl={_verifyUrl}
          phoneNum={phoneNumber}
          inputValue={PictureCode}
          pictureCodeErrorMsg={pictureCodeErrorMsg}
          verifyPictureCodeChange={(value) =>
            this.verifyPictureCodeChange(value)
          }
          changeVerifyPictureCode={() => this.changeVerifyPictureCode()}
          sendVerifyCode={() => this.sendVerifyCode()}
          onCancel={() => {
            this.setState({
              showCodeModal: false,
              pictureCodeErrorMsg: "",
              PictureCode: "",
            });
          }}
        />
      </div>
    );
  }
}

export default PhoneInput;



// WEBPACK FOOTER //
// src/pc/components/PhoneInput.jsx